import axios from 'axios';
import { getToken, logout } from './auth';

const api = axios.create({
   baseURL: process.env.REACT_APP_BASE_URL_API || 'http://localhost:61447/v1/'
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && error?.response?.data?.complemento?.codigo === '002') {
      const canRedirect = logout();
      if (canRedirect) {
        window.location = '/app';
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default api;
